import React, { useState } from 'react';
import { Row, Container, TabContent, TabPane } from 'reactstrap';
import { reduxForm } from 'redux-form';
import NavTab from '../../../shared/components/custom/NavTab';
import { partial } from '../../../util/translation/translation';
import PersonCardForm from './PersonCardForm';
import CompanyCardForm from './CompanyCardForm';
import GuestCardForm from './GuestCardForm';
import EmailInviteModal from './EmailInviteModal';

const InviteParticipantsModal = ({
  companies,
  handleSubmit,
  currentParticipant,
  participantType,
  event,
  setMaxGuestAmount,
  maxGuestAmount,
}) => {
  const s = partial('shared');

  // A participant being edited is one of COMPANY, USER, or GUEST (see
  // participant.type in EventsParticipantForm) - this maps that type to
  // the tab that owns editing it.
  const editTabByType = { COMPANY: '1', USER: '2', GUEST: '3' };
  const editTab = currentParticipant
    ? editTabByType[currentParticipant.type]
    : null;
  const [activeTab, setActiveTab] = useState(
    editTab ?? (participantType !== 'person' ? '1' : '2')
  );
  return (
    <div className="form">
      <Container
        style={{
          padding: 0,
          marginBottom: 10,
          paddingBottom: 5,
          background: '#fff',
          borderRadius: 6,
          border: '1px solid rgba(0,0,0,0.08)',
        }}
      >
        <NavTab
          tabs={[
            {
              tab: s('company'),
              disabled: !!currentParticipant && editTab !== '1',
            },
            {
              tab: s('user'),
              disabled: !!currentParticipant && editTab !== '2',
            },
            {
              tab: s('guest'),
              disabled: !!currentParticipant && editTab !== '3',
            },
            { tab: s('email'), disabled: !!currentParticipant },
          ]}
          activeTab={activeTab}
          setTab={setActiveTab}
          queryName="participantTab"
          size="sm"
        />
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <CompanyCardForm
              companies={companies}
              onSubmit={handleSubmit}
              participant={editTab === '1' ? currentParticipant : null}
            />
          </TabPane>
          <TabPane tabId="2">
            <PersonCardForm
              onSubmit={handleSubmit}
              participant={editTab === '2' ? currentParticipant : null}
              event={event}
              maxGuestAmount={maxGuestAmount}
              setMaxGuestAmount={setMaxGuestAmount}
            />
          </TabPane>
          <TabPane tabId="3">
            <GuestCardForm
              onSubmit={handleSubmit}
              event={event}
              participant={editTab === '3' ? currentParticipant : null}
              maxGuestAmount={maxGuestAmount}
            />
          </TabPane>
          <TabPane tabId="4">
            <EmailInviteModal event={event} />
          </TabPane>
        </TabContent>
      </Container>
    </div>
  );
};

const reduxF = reduxForm({
  form: 'InviteParticipantsCard',
  enableReinitialize: true,
});

export default reduxF(InviteParticipantsModal);
